class Panel {
  /**
   * @param {HTMLElement[]} panels
   */
  constructor(panels) {
    this.panels = panels;
    this.panelIndex = 0;
    this.currentPanel = this.panels[this.panelIndex] ? this.panels[this.panelIndex] : null;
    this.__init();
  }

  __init() {
    this.currentPanel.classList.add("panel", "panel__centered");
    this.panels.slice(1).forEach(p => {
      p.classList.add("panel", "panel__right");
      p.style.display = "none";
    });
  }

  /**
   * Show next panel
   */
  next() {
    if (!this.panels.length) {
      return;
    }

    const panelOut = this.panels[this.panelIndex];
    const panelIn = this.panels[this.panelIndex + 1] ? this.panels[this.panelIndex + 1] : null;
    if (!panelIn) {
      return;
    }

    this.panelIndex += 1;
    // Show panel to slide
    panelIn.style.display = "";

    setTimeout(
      () => {
        panelOut.classList.add("panel__left");
        panelOut.classList.remove("panel__centered");
        panelIn.classList.add("panel__centered");
        panelIn.classList.remove("panel__right");
        // Hide panel removed
        setTimeout(
          () => {
            panelOut.style.display = "none";
          },
          155,
        );
      },
      5,
    );
  }

  /**
   * Show previous panel
   */
  back() {
    if (!this.panels.length) {
      return;
    }

    const panelOut = this.panels[this.panelIndex];
    const panelIn = this.panels[this.panelIndex - 1] ? this.panels[this.panelIndex - 1] : null;
    if (!panelIn) {
      return;
    }

    this.panelIndex -= 1;
    // Show panel to slide
    panelIn.style.display = "";

    setTimeout(
      () => {
        panelOut.classList.remove("panel__centered");
        panelOut.classList.add("panel__right");
        panelIn.classList.add("panel__centered");
        panelIn.classList.remove("panel__left");

        // Hide panel removed
        setTimeout(
          () => {
            panelOut.style.display = "none";
          },
          155,
        );
      },
      5,
    );
  }
}

export default Panel;
